/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export { ConfirmationDialog } from './confirmation-dialog';
